type FirebaseSessionIdentity = {
  uid: string;
  lastSignInTime?: string;
};

type ActiveFirebaseSession = {
  uid: string;
  lastSignInTime?: string;
  key: string;
};

/**
 * Gives each real authentication session a stable in-memory identity.
 *
 * Firebase may remount the provider tree or briefly restore the same User
 * object, so the key must survive ordinary React lifecycles. A completed
 * sign-out explicitly ends the session; signing into the same account again
 * then receives a new key and therefore a fresh readiness curtain.
 */
export function createFirebaseSessionRegistry() {
  let active: ActiveFirebaseSession | null = null;
  let sequence = 0;

  return {
    begin(identity: FirebaseSessionIdentity): string {
      if (
        active?.uid === identity.uid &&
        active.lastSignInTime === identity.lastSignInTime
      ) {
        return active.key;
      }

      const key = `firebase:${identity.uid}:${++sequence}`;
      active = {
        uid: identity.uid,
        lastSignInTime: identity.lastSignInTime,
        key
      };
      return key;
    },

    end(uid?: string): void {
      if (!uid || active?.uid === uid) active = null;
    }
  };
}

export const firebaseSessionRegistry = createFirebaseSessionRegistry();
